import {ProjectEditPageGrid, ProjectEditPageGridRow} from "../../projectEdit/styles";
import {LangBlockWrapper} from "../styles";
import React, {FC} from "react";
import {FlexBox, useBreakpoint, useToasts} from "@brg/ui";
import styled from "styled-components";
import {CustomHollowButton, RectangularButtonFilled, RectangularButtonHollow} from "../../../components/buttons";
import {LayoutConst} from "../../../../core";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import { LoaderSpinner } from "shared/modals/artzLegalsModal/LoaderAnimation";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { LangTitleWrapper } from "shared/components/LangTitleBox/styles";

const Container = styled.div`
    .lang-label-block, .lang-container {
        width: 224px;
        min-width: 224px;
        margin-right: 24px;
        margin-top: 10px;
   
        @media(max-width: ${LayoutConst.screen.m}px) {
            width: 160px;
            min-width: 160px;
            margin-right: 16px !important;
        }

        @media(max-width: ${LayoutConst.screen.s-1}px) {
          width: 100%;
          margin-right: 0px !important;
          max-height: 28px;
            margin-top: 0px;
        }

        h6 {
            margin-bottom: 0px;
        }
    }

    ${LangBlockWrapper}, ${LangTitleWrapper} {
        @media(max-width: ${LayoutConst.screen.m}px) {
            place-items: flex-start !important;
        }
    }
`;

const Grid = styled(ProjectEditPageGrid)`

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin: 0 auto;
        padding-top: 24px;
        justify-content: center;
        max-width: 100%;
    
        > div {
            width: 100%;
            max-width: 100%;
        }

        ${ProjectEditPageGridRow}, ${ProjectEditPageGridInput}, ${LangBlockWrapper} {
            max-width: 100%;
        }
    }
    
    @media(max-width: ${LayoutConst.screen.md}px) {
        margin: 0 auto;
        padding-top: 24px;
        justify-content: center;
        max-width: calc(100vw - 32px);

        > div {
            width: 100%;
            max-width: 100%;
        }

        ${ProjectEditPageGridRow}, ${ProjectEditPageGridInput}, ${LangBlockWrapper} {
            max-width: 100%;

            input, textarea {
                width: 100% !important;
            }
        }

        ${LangBlockWrapper} {
            margin-top: 32px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s-1}px) {
        max-width: calc(100vw - 20px);

        ${LangBlockWrapper} {
            margin-top: 24px;
        }

        input {
            max-height: 36px;
            width: 100%;
            max-width: 100%;
            min-width: 100%;
        }

        textarea {
            min-height: 183px !important;
            max-height: 183px !important;
        }

        .cover-container {
            flex-wrap: wrap;

            span {
                white-space: nowrap;
                text-overflow: ellipsis;
                max-width: calc(100vw - 20px);
            }
        }
    }
`;

const Button = styled(RectangularButtonFilled)`
  height: 48px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto !important;
  width: auto !important;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.projectEdit?.btns?.navbar?.disabled?.bg} !important;
    color: ${({ theme }) => theme.projectEdit?.btns?.navbar?.disabled?.color} !important;
  }
`;

const CustomButton = styled(CustomHollowButton)`
  border: 1px solid ${({ theme }) => theme.projectEdit.btns.navbar.exit.border.notActive.color};
  height: 48px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto;
  width: auto;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }
`;


export const ChannelEdit: FC<{ 
    channelTab?: any, 
    isLoading?: boolean,  
    onSave?: any, 
    onCancel?: () => void,
    canSaveLgText?: any, 
    setIsTeamDeleted?: any, 
}> = ({ 
    isLoading, 
    channelTab, 
    onSave, 
    canSaveLgText,
    onCancel 
}) => {

    const { t } = useTranslation()
    const history = useHistory()
    const msg = useToasts()
    const isMobile = useBreakpoint(LayoutConst.screen.s-1);

    if (isLoading) {
        return (
            <LoaderSpinner text={'Сохранение'} color="#909090"/>
        )
    }

    return (
        <Container>
            <Grid isTeamPage>
                {channelTab}
                <FlexBox 
                    gx={12} 
                    offsetTop={40} 
                    offsetTopMobile={isMobile ? 32 : 40}
                    direction="row"
                    directionMobile={isMobile ? 'column' : 'row'}
                    gxMobile={isMobile ? 1 : 12}
                    gyMobile={isMobile ? 8 : 1}
                >
                    <CustomButton onClick={onCancel}>
                        {t("nav.exit")}
                    </CustomButton>
                    <Button onClick={onSave} disabled={!canSaveLgText}>
                        {t("save")}
                    </Button>
                </FlexBox>
            </Grid>
        </Container>
    )
}import {ProjectEditPageGrid, ProjectEditPageGridRow} from "../../projectEdit/styles";
import {LangBlockWrapper} from "../styles";
import React, {FC} from "react";
import {FlexBox, useBreakpoint, useToasts} from "@brg/ui";
import styled from "styled-components";
import {CustomHollowButton, RectangularButtonFilled, RectangularButtonHollow} from "../../../components/buttons";
import {LayoutConst} from "../../../../core";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import { LoaderSpinner } from "shared/modals/artzLegalsModal/LoaderAnimation";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { LangTitleWrapper } from "shared/components/LangTitleBox/styles";

const Container = styled.div`
    .lang-label-block, .lang-container {
        width: 224px;
        min-width: 224px;
        margin-right: 24px;
        margin-top: 10px;
   
        @media(max-width: ${LayoutConst.screen.m}px) {
            width: 160px;
            min-width: 160px;
            margin-right: 16px !important;
        }

        @media(max-width: ${LayoutConst.screen.s-1}px) {
          width: 100%;
          margin-right: 0px !important;
          max-height: 28px;
            margin-top: 0px;
        }

        h6 {
            margin-bottom: 0px;
        }
    }

    ${LangBlockWrapper}, ${LangTitleWrapper} {
        @media(max-width: ${LayoutConst.screen.m}px) {
            place-items: flex-start !important;
        }
    }
`;

const Grid = styled(ProjectEditPageGrid)`

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin: 0 auto;
        padding-top: 24px;
        justify-content: center;
        max-width: 100%;
    
        > div {
            width: 100%;
            max-width: 100%;
        }

        ${ProjectEditPageGridRow}, ${ProjectEditPageGridInput}, ${LangBlockWrapper} {
            max-width: 100%;
        }
    }
    
    @media(max-width: ${LayoutConst.screen.md}px) {
        margin: 0 auto;
        padding-top: 24px;
        justify-content: center;
        max-width: calc(100vw - 32px);

        > div {
            width: 100%;
            max-width: 100%;
        }

        ${ProjectEditPageGridRow}, ${ProjectEditPageGridInput}, ${LangBlockWrapper} {
            max-width: 100%;

            input, textarea {
                width: 100% !important;
            }
        }

        ${LangBlockWrapper} {
            margin-top: 32px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s-1}px) {
        max-width: calc(100vw - 20px);

        ${LangBlockWrapper} {
            margin-top: 24px;
        }

        input {
            max-height: 36px;
            width: 100%;
            max-width: 100%;
            min-width: 100%;
        }

        textarea {
            min-height: 183px !important;
            max-height: 183px !important;
        }

        .cover-container {
            flex-wrap: wrap;

            span {
                white-space: nowrap;
                text-overflow: ellipsis;
                max-width: calc(100vw - 20px);
            }
        }
    }
`;

const Button = styled(RectangularButtonFilled)`
  height: 48px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto !important;
  width: auto !important;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.projectEdit?.btns?.navbar?.disabled?.bg} !important;
    color: ${({ theme }) => theme.projectEdit?.btns?.navbar?.disabled?.color} !important;
  }
`;

const CustomButton = styled(CustomHollowButton)`
  border: 1px solid ${({ theme }) => theme.projectEdit.btns.navbar.exit.border.notActive.color};
  height: 48px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto;
  width: auto;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }
`;


export const ChannelEdit: FC<{ 
    channelTab?: any, 
    isLoading?: boolean,  
    onSave?: any, 
    onCancel?: () => void,
    canSaveLgText?: any, 
    setIsTeamDeleted?: any, 
}> = ({ 
    isLoading, 
    channelTab, 
    onSave, 
    canSaveLgText,
    onCancel 
}) => {

    const { t } = useTranslation()
    const history = useHistory()
    const msg = useToasts()
    const isMobile = useBreakpoint(LayoutConst.screen.s-1);

    if (isLoading) {
        return (
            <LoaderSpinner text={'Сохранение'} color="#909090"/>
        )
    }

    return (
        <Container>
            <Grid isTeamPage>
                {channelTab}
                <FlexBox 
                    gx={12} 
                    offsetTop={40} 
                    offsetTopMobile={isMobile ? 32 : 40}
                    direction="row"
                    directionMobile={isMobile ? 'column' : 'row'}
                    gxMobile={isMobile ? 1 : 12}
                    gyMobile={isMobile ? 8 : 1}
                >
                    <CustomButton onClick={onCancel}>
                        {t("nav.exit")}
                    </CustomButton>
                    <Button onClick={onSave} disabled={!canSaveLgText}>
                        {t("save")}
                    </Button>
                </FlexBox>
            </Grid>
        </Container>
    )
}